//#region imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { SignatureRoutingModule } from './signature-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SignatureComponent } from './components/signature/signature.component';
import { SignatureQuestion1Component } from './components/signature-question1/signature-question1.component';
import { SignatureQuestion2Component } from './components/signature-question2/signature-question2.component';
import { SignatureQuestion3Component } from './components/signature-question3/signature-question3.component';
import { SignatureQuestion4Component } from './components/signature-question4/signature-question4.component';
import { SignatureQuestion5Component } from './components/signature-question5/signature-question5.component';
import { SignatureQuestion6Component } from './components/signature-question6/signature-question6.component';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule, MatNativeDateModule, MatFormFieldModule, MatSelectModule, MatAutocompleteModule, MAT_DATE_LOCALE, MatIconModule } from '@angular/material';
import { GestureConfig } from '@angular/material';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { SignatureThanksComponent } from './components/signature-thanks/signature-thanks.component';
import { AgmCoreModule } from '@agm/core';
import { environment } from 'src/environments/environment';
import { SignatureRefuseComponent } from './components/signature-refuse/signature-refuse.component';
//#endregion

@NgModule({
  declarations: [
    SignatureComponent, SignatureQuestion1Component, SignatureQuestion2Component, SignatureQuestion3Component,
    SignatureQuestion4Component, SignatureQuestion5Component, SignatureQuestion6Component, SignatureThanksComponent, SignatureRefuseComponent
  ],
  imports: [
    SharedModule, CommonModule,
    SignatureRoutingModule,
    ProgressbarModule.forRoot(),
    FormsModule,
    ReactiveFormsModule, MatDatepickerModule, MatInputModule, MatNativeDateModule, MatFormFieldModule,
    MatSelectModule, MatAutocompleteModule, MatIconModule,
    AgmCoreModule.forRoot({
      apiKey: environment.mapKey // 'AIzaSyAth9U0MYMPLAiaUk3rGMd0yiIE-3B-1SQ'
    })
  ],
  exports: [
    SignatureComponent, SignatureQuestion1Component, SignatureQuestion2Component, SignatureQuestion3Component,
    SignatureQuestion4Component, SignatureQuestion5Component, SignatureQuestion6Component, SignatureThanksComponent, SignatureRefuseComponent
  ],
  providers: [{ provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
              {provide: MAT_DATE_LOCALE, useValue: 'en-GB'}]
})
export class SignatureModule { }

